import { lang } from '@/tool/lang'
import { myHTTP } from '@/utils/net'
import queryString from 'query-string'

const parsed = queryString.parse(location.search || '') || {}

export default {
    props: ['language'],
    data() {
        var validateId = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.newArr[0][34]))
            } else {
                callback()
            }
        }
        var validateRedemption = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.newArr[0][35]))
            } else {
                callback()
            }
        }
        var validateVerification = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.newArr[0][36]))
            } else {
                callback()
            }
        }
        return {
            isMessage: false,
            isModal: false,
            isLoading: false,
            isNo: false,
            isYes: false,
            isClick: true,
            isOk: false,
            ruleForm: {
                id: '',
                redemption: '',
                verification: ''
            },
            rules: {
                id: [{ required: true, trigger: ['blur', 'change'], validator: validateId }],
                redemption: [{ required: true, trigger: ['blur', 'change'], validator: validateRedemption }],
                verification: [{ required: true, trigger: ['blur', 'change'], validator: validateVerification }]
            },
            options: [
                { value: 'en', label: 'English' },
                { value: 'ja', label: '日本語' },
                { value: 'ko', label: '한국어' },
                { value: 'zh-TW', label: '繁體中文' }
            ],
            selectValue: 'en',
            newArr: [{}],
            verificationCode: '',
            captchaId: '',
            message: '',
            isDisable: true,
            codeLoaded: false
        }
    },
    watch: {
        isModal(val) {
            if (val) {
                var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
                document.body.style.overflow = 'hidden'
                document.body.style.paddingRight = scrollbarWidth + 'px'
            } else {
                document.body.style.overflow = ''
                document.body.style.paddingRight = ''
            }
        },
        selectValue(val) {
            if (val) {
                this.getLang(this.selectValue)
                this.$nextTick(() => {
                    this.$refs['ruleForm'][0].clearValidate()
                })
            }
        },
        'ruleForm.id'() {
            this.checkFields()
        },
        'ruleForm.redemption'() {
            this.checkFields()
        },
        'ruleForm.verification'() {
            this.checkFields()
        }
    },
    created() {
        this.selectValue = this.language || 'en'
        this.getLang(this.selectValue)
        this.getId()

        if (parsed.code) {
            this.ruleForm.redemption = parsed.code
        }
    },
    methods: {
        checkFields() {
            if (this.ruleForm.id && this.ruleForm.redemption && this.ruleForm.verification) {
                this.isDisable = false
            }
        },
        getLang(language) {
            for (var i in lang) {
                this.newArr[0][i] = lang[i][language]
            }
        },
        submitForm() {
            if (this.isDisable === true) {
                return
            }
            this.$refs['ruleForm'][0].validate(valid => {
                if (valid) {
                    this.isModal = true
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        handleYes() {
            if (this.isMessage) {
                this.isMessage = false
                this.isModal = false
            } else {
                this.isLoading = true
                this.claim()
                this.getId()
            }
        },
        handleOk() {
            this.isOk = true
            this.isModal = false
            this.isOk = false
            this.isMessage = false
        },
        handleNo() {
            this.isMessage = false
            this.isNo = true
            this.isModal = false
            this.isNo = false
        },
        getId() {
            this.codeLoaded = false
            myHTTP.post('/api/v1/captcha/generate').then(res => {
                this.captchaId = res.data.data.captchaId
                myHTTP.get(`/api/v1/captcha/image/${res.data.data.captchaId}`).then(res => {
                    this.verificationCode = res.config.url
                    this.isClick = true
                })
            })
        },
        refresh() {
            if (this.isClick) {
                this.isClick = false
                this.getId()
            }
        },
        claim() {
            this.isDisable = true
            let aclaim = ''
            if (this.ruleForm.id.indexOf('-') !== -1) {
                aclaim = this.ruleForm.id.replace(/\s/g, '').split('-')[1]
            } else {
                aclaim = this.ruleForm.id.replace(/\s/g, '')
            }
            myHTTP
                .post('/api/v1/giftcode/claim', {
                    userId: aclaim,
                    giftCode: this.ruleForm.redemption.replace(/\s/g, ''),
                    captcha: this.ruleForm.verification.replace(/\s/g, ''),
                    captchaId: this.captchaId.replace(/\s/g, '')
                })
                .then(res => {
                    this.isDisable = false
                    this.isLoading = false
                    this.isMessage = true
                    this.isModal = true
                    let code = res.data.code
                    if (code === 0) {
                        this.message = this.newArr[0][21]
                    } else if (code === 20001) {
                        this.message = this.newArr[0][22]
                    } else if (code === 20002) {
                        this.message = this.newArr[0][23]
                    } else if (code === 20003) {
                        this.message = this.newArr[0][24]
                    } else if (code === 20401) {
                        this.message = this.newArr[0][25]
                    } else if (code === 20402) {
                        this.message = this.newArr[0][26]
                    } else if (code === 20403) {
                        this.message = this.newArr[0][27]
                    } else if (code === 20404) {
                        this.message = this.newArr[0][28]
                    } else if (code === 20407) {
                        this.message = this.newArr[0][29]
                    } else if (code === 20409) {
                        this.message = this.newArr[0][30]
                    } else if (code === 20410) {
                        this.message = this.newArr[0][31]
                    } else if (code === 30001) {
                        this.message = this.newArr[0][32]
                    } else {
                        this.message = this.newArr[0][32] + '(' + code + ')'
                    }
                })
        }
    }
}
